import toast from 'components/Toast/dispatch';

const TOTAL_ORDERS_DOWNLOAD_IN_LOT = 300;

export const ValidateLimitDownloadInLot = (totalOrders = 0, documentName = "notas fiscais") => {

  if (totalOrders > TOTAL_ORDERS_DOWNLOAD_IN_LOT) {
    toast.info('Limite atingido', 'É possível marcar até ' + TOTAL_ORDERS_DOWNLOAD_IN_LOT +
      ' ' + documentName + ' para download em lote e sua seleção atingiu esse limite.' +
      ' Restrinja o período selecionado ou verifique as notas marcadas para dar continuidade.');
    return true;
  }

  return false;
};